import eventManager from 'common/services/-RFC.eventManager';

/**
 * Listen events for Actions Model
 */
angular.module('listeners')
    .service('ActionsListener', (ActionsRepository) => {

        eventManager.subscribe('socket:actions', (response) => {

            if (response.verb === 'PUT') {

                ActionsRepository.update(response.payload.data);

            }

        });

    });



// WEBPACK FOOTER //
// ./scripts/common/listeners/actions.js